import {z} from "zod"
import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {AddressMode, box2Like, vector2Like} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/basic-definitions"

export const BlitOutOfBoundsHandling = z.union([z.literal("wrap"), z.literal("clip")])

export const Definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            backgroundImage: anyImageOpResult,
            foregroundImage: anyImageOpResult,
            foregroundRegion: box2Like.optional(),
            foregroundAddressMode: AddressMode.optional().default("clamp"),
            position: vector2Like.optional().default({x: 0, y: 0}),
            outOfBoundsHandling: BlitOutOfBoundsHandling.optional().default("clip"),
            // Only safe when `backgroundImage` is provably not referenced by anything else in the graph (e.g. an
            // intermediate result this same caller produced and will not use again) - see clone-stamp's stroke loop.
            inPlace: z.boolean().optional().default(false),
        }),
    },
}
